import development from '../app-dev.json';
import production from '../app.json';

const knownApps = { development, production };
const env = process.env.NODE_ENV || 'production';

const appDef = knownApps[env] || knownApps['production'];

export default appDef.config;
export const host = appDef.config.host;
